import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminCommonHttpService } from '../service/admin-common-http.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-manage-order',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manage-order.component.html',
  styleUrls: ['./manage-order.component.css']
})
export class ManageOrderComponent {

  public orders: any;
  public customerId: string | null = null;
  public showAllOrders = false;
  public loading = false;
  public error = '';
  public expandedOrderId: string | null = null;
  public orderDetailsMap = new Map<string, any>();


  constructor(private route: ActivatedRoute, private apiService: AdminCommonHttpService) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.customerId = params['customer_id'] || null;
    });

    if (this.customerId) {
      this.showAllOrders = false;
      this.fetchOrders(this.customerId);
    } else {
      this.fetchOrders(null);
      this.showAllOrders = true;
    }


  }

  async fetchOrders(customer_id: string | null): Promise<void> {
    try {
      this.loading = true;
      this.orders = customer_id
        ? await this.apiService.getOrdersByCustomerId(customer_id)
        : await this.apiService.getAllOrders();
      console.log('Fetched orders:', this.orders);
    } catch (err) {
      console.error('Error fetching orders:', err);
      this.error = 'Failed to load orders';
    } finally {
      this.loading = false;
    }
  }

  expandedOrders = new Set<string>();

  async toggleExpand(orderId: string): Promise<void> {
    if (this.expandedOrders.has(orderId)) {
      this.expandedOrders.delete(orderId);
      return;
    }

    if (!this.orderDetailsMap.has(orderId)) {
      const details = await this.apiService.getOrderById(orderId);
      this.orderDetailsMap.set(orderId, details);
    }

    this.expandedOrders.add(orderId);
  }



}
